import { UnicornApi } from '@cld/unicorn-api';

type Permission = UnicornApi['data']['permissions'][number];
type UserRole = UnicornApi['data']['user']['role'];

export const shouldRedirectToOnboarding = (loginFromSession: { user_events_latest: Array<{ kind: string }> }) => {
  const hasOnboardingEvent = loginFromSession.user_events_latest.some(({ kind }) => kind === 'onboarding_status');
  return !hasOnboardingEvent;
};

export const isAllowedForOnboarding = ({
  user,
  permissions,
}: {
  user: { isCloudinaryAdminEmployee: boolean; role: UserRole };
  permissions: Permission[];
}) => {
  const disallowedRoles = ['billing', 'media_library_user', 'reports', 'media_library_admin'];

  return (
    (user.isCloudinaryAdminEmployee || // internal admin permissions are handled by legacy UI
      permissions.includes('modifyCloudSettings') ||
      permissions.includes('modifyAccountSettings')) &&
    !disallowedRoles.includes(user.role)
  );
};
